var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoYrSecondary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 24,
    fill: "none",
    viewBox: "0 0 39 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003792",
    fillRule: "evenodd",
    d: "M35.206 18.028c.77.824 1.8.536 1.8.536L37 21.98h-2.5c-.028.002-.059.006-.087.006-.028 0-.059-.004-.087-.006h-.092v-.002a2.142 2.142 0 0 1-1.299-.589l-.318-.392-4.545-5.567H26.39c-1.15.002-2.113.963-2.115 2.112v4.438h-4.224V6.339A6.351 6.351 0 0 1 26.39 0h3.725c2.114.002 4.145.606 5.721 1.907 1.583 1.286 2.585 3.337 2.564 5.62.008 2.194-.78 4.235-2.228 5.675-.9.907-2.036 1.555-3.3 1.91 0 0 1.43 1.948 2.334 2.916zM33.14 5.16c-.653-.548-1.708-.935-3.027-.933h-3.725a2.14 2.14 0 0 0-2.112 2.112v5.403c.66-.233 1.37-.536 2.112-.538h4.108c1.236-.005 2.09-.399 2.69-.99.589-.597.983-1.454.99-2.69-.022-1.148-.39-1.804-1.035-2.364m-15.832 9.372c-.02 5.632-4.06 7.426-5.598 8.322l-2.654-3.21.06-.031-.06-.074c.854-.428 4.025-2.054 4.025-4.547V13.11c-.438.885-2.696 1.887-4.232 1.916h-.17c-2.29-.04-4.384-.848-5.912-2.287C1.08 11.15.188 8.945.188 6.365V.68h4.121v5.685c0 3.306 2.287 4.51 4.456 4.54 1.898-.026 4.283-.85 4.361-3.396L13.131.68h4.178v13.852z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYrSecondary);
export default __webpack_public_path__ + "static/media/logo-yr-secondary.19edd3fc.svg";
export { ForwardRef as ReactComponent };